import { useQuery } from '@tanstack/react-query';
import { schoolService } from '../../../services';

export const useSchools = () => {
  const {
    data: schoolsResponse,
    isLoading: isLoadingSchools,
    isError: isErrorSchools,
    error: schoolsError,
  } = useQuery({
    queryKey: ['schools'],
    queryFn: () => schoolService.getSchools(),
    staleTime: 10 * 60 * 1000, // 10 phút
    gcTime: 30 * 60 * 1000, // 30 phút
  });

  return {
    schoolsResponse,
    isLoadingSchools,
    isErrorSchools,
    schoolsError,
  };
};
